import '../css/Certifications.css';
import {certificates} from '../data/certificates';

const Certifications = () => {
    return (
            <div className='Certifications'>
                <div className='certifications-header'>
                    <h2>Certifications</h2>
                </div>
                <div className='certifications-div'>
                {
                    
                        certificates.map((certificate) => {
                            return (
                                <div key={certificate.id} className='cert-div'>
                                    <div className='cert-date'>
                                        <p>{certificate.date}</p>
                                    </div>
                                    <div className='cert-name'>
                                        <a href={certificate.link}>{certificate.name}</a>
                                    </div>
                                </div>
                            );
                        })                   
                }
                </div>
                                    {/* <div className='certifications-blocks'>
                                    <img src={require('../assets/certifications/microsoftcert.png')} alt="azure"/>
                                    <img src={require('../assets/certifications/sparkarcert.png')} alt="sparkar"/>
                                    </div> */}
            </div>
    );
}

export default Certifications;